<template>
    <main class="flex-1 relative pb-8 z-0 overflow-y-auto">
        <PageHeader>
            <h1 class="ml-3 text-2xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">
                <span>
                    <span class="flex flex-row items-center">
                        Corporation -
                        <template v-if="isCorporationFetchPending">
                            <Loader class="h-6 w-6 m-2 border-2 -red"/>
                        </template>
                        <template v-else>
                            {{ corporation ? corporation.translatable.name[locale] : '' }}
                        </template>
                        <button v-if="isRoot" type="button" @click.prevent="handleEditSettings">
                            <svg-vue icon="setting" class="h-8 w-8 text-custom-300" />
                        </button>
                    </span>
                    <LangSwitcher />
                </span>
                <span v-if="isRoot">
                    <button v-if="isRoot" @click.prevent="handleCreateDomain" class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-custom-600 hover:bg-custom-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                        Create domain
                    </button>
                </span>
            </h1>
        </PageHeader>

        <div class="mt-8 lg:max-w-6xl lg:mx-auto">
            <h2 class="ml-3 text-1xl font-bold text-gray-900 sm:truncate flex flex-row justify-between w-full">Domains</h2>
            <div class="m-4">
                <List
                    :items="domains"
                    :columns="columns"
                    :desc="desc"
                    @editItem="handleEditDomain"
                    @deleteItem="handleDeleteDomain"
                    @manageItem="handleManageDomain"
                    editable
                    deletable
                    manageable
                />
            </div>
        </div>
    </main>
</template>

<script>
import PageHeader from "../../components/partials/page-header";
import Loader from "../../components/partials/loader";
import LangSwitcher from "../../components/partials/lang-switcher";
import List from "../../components/partials/list"
import USER_ROLE from "../../enums/user-role";

export default {
    data() {
        return {
            desc: false
        }
    },
    beforeMount() {
        this.$store.dispatch('corporations/getSingle', {id: this.$route.params.id, includes: ['domains', 'settings']})
    },
    computed: {
        isCorporationFetchPending() {
            return this.$store.state.corporations.isFetchSinglePending
        },
        errors() {
            return this.$store.state.units.errors;
        },
        locale() {
            return this.$store.state.config.locale;
        },
        corporation() {
            return this.$store.state.corporations.single;
        },
        domains() {
            return this.corporation && this.corporation.domains ? this.corporation.domains.data : [];
        },
        authUser() {
            return this.$store.state.auth.auth_user;
        },
        isRoot() {
            if(this.authUser) {
                return Number(this.authUser.role) === Number(USER_ROLE.values.ROOT.description)
            }

            return false
        },
        columns() {
            return {
                id: {},
                name: {},
                title: {},
                subtitle: {}
            }
        }
    },
    methods: {
        handleEditSettings() {
            this.$store.dispatch('modals/open', 'corporation_settings-save')
        },
        handleCreateDomain() {
            this.$store.dispatch('domains/resetSingle');
            this.$store.dispatch('modals/open', 'domain-save')
        },
        handleEditDomain(domain) {
            this.$store.dispatch('domains/setSingle', domain);
            this.$store.dispatch('modals/open', 'domain-save')
        },
        handleDeleteDomain(domain) {
            this.$store.dispatch('domains/setSingle', domain);
            this.$store.dispatch('modals/open', 'domain-delete')
        },
        handleManageDomain(domain) {
            this.$router.push({name: 'domain-show', params: {id: domain.id}})
        },
    },
    components: {
        PageHeader,
        Loader,
        LangSwitcher,
        List,
    }
}
</script>
